export enum AppRoutesEnum {
  DASHBOARD_ROUTE = '/',
  LOGIN_ROUTE = 'login',
  REGISTER_ROUTE = 'register',
  RESET_PASSWORD_ROUTE = 'reset-password',
  SET_PASSWORD_ROUTE = 'set-password',
  TEAM_INVITATION_CONFIRM_ROUTE = 'team-invitation/confirm',
  PAYMENT_FAILED_ROUTE = 'payment/failed',
  SHOPIFY_INSTALLATION_ROUTE = 'shopify/installation',
  MAINTENANCE_ROUTE = 'maintenance',
}

export enum StaticTextRoutesEnum {
  PRIVACY = 'privacy-and-cookies',
  TERMS = 'terms',
  META_PRIVACY = 'meta-privacy-policy',
}

export enum DashboardRoutesEnum {
  BASE_ROUTE = '/',
  TEMPLATES_ROUTE = 'templates',
  RECENT_ROUTE = 'recent',
  STARRED_ROUTE = 'starred',
  USER_ROUTE = 'user',
  ADMIN_ROUTE = 'admin',
  ONBOARDING_ROUTE = 'onboarding',
  TEAM_ROUTE = 'teams/:teamId',
  PROJECT_ROUTE = 'projects/:projectId',
}

export enum TeamRoutesEnum {
  MAIN_ROUTE = '/',
  BRAND_KIT_ROUTE = 'brand-kit',
  MEMBERS_ROUTE = 'members',
  ASSETS_ROUTE = 'assets',
  PROJECTS_ROUTE = 'projects',
  STYLES_ROUTE = 'styles',
  SETTINGS_ROUTE = 'settings',
  PLUGIN_TOKENS_ROUTE = 'plugin-tokens',
}

export enum AdminTeamRoutesEnum {
  MAIN_ROUTE = '/',
  STYLES_ROUTE = 'styles',
  MEMBERS_ROUTE = 'members',
  PROJECTS_ROUTE = 'projects',
  GENERAL_ROUTE = 'general',
}

export enum AdminTemplateRoutesEnum {
  MAIN_ROUTE = '/',
  GENERAL_ROUTE = 'general',
  TAGS_ROUTE = 'tags',
}

export enum ProjectRoutesEnum {
  MAIN_ROUTE = '/',
  SUMMARY = 'summary',
  DESIGNS_ROUTE = 'designs',
  /** DesignManager3, which is what "the editor" means now. */
  DESIGN_EDITOR_ROUTE = 'designs/:designId/editor',
  /**
   * DesignManager2, kept reachable for a design the new editor cannot open.
   * Nothing links to it — it is a url an admin types.
   */
  DESIGN_EDITOR_LEGACY_ROUTE = 'designs/:designId/editor-legacy',
  DESIGN_PREVIEW_ROUTE = 'designs/:designId/preview',
  SETTINGS_ROUTE = 'settings',
  SOURCE_FEED = 'sourcefeed',
  FEED_CONNECT = 'feed',
  PREVIEW = 'preview',
  CAMPAIGNS = 'campaigns',
}

export enum ProjectSettingsRoutesEnum {
  GENERAL = 'general',
  BILLING_PLAN = 'billing-plan',
  PRODUCT_DATA_OVERRIDES = 'product-data-overrides',
  PLUGIN_TOKENS = 'plugin-tokens',
}

export enum ProjectBillingPlanRoutesEnum {
  CHANGE = 'change',
}

export enum ProjectSharedPreviewRoutesEnum {
  PROJECT_SHARE_PREVIEW = 'project/preview/:projectId/:token',
}

export enum DesignSharedPreviewRoutesEnum {
  DESIGN_SHARE_PREVIEW = 'design/preview/:designId/:token',
}

export enum UserRoutesEnum {
  MAIN_ROUTE = '/',
  ACCOUNT_ROUTE = 'account',
  BILLING_ROUTE = 'billing',
  PAYMENTS_ROUTE = 'payments',
  PASSWORD_ROUTE = 'password',
}

export enum AdminRoutesEnum {
  USERS_ROUTE = 'users',
  TEAMS_ROUTE = 'teams',
  PROJECTS_ROUTE = 'projects',
  TEMPLATES_ROUTE = 'templates',
  STYLES_ROUTE = 'globalstyles',
  STYLE_MANAGER_WIZARD = 'createstyle',
  TEMPLATE_GROUPS_ROUTE = 'templategroups',
  FONTS_ROUTE = 'fonts',
  INSERTS_ROUTE = 'inserts',
}

export enum AdminTemplateGroupRoutesEnum {
  MAIN_ROUTE = '/',
  GENERAL_ROUTE = 'general',
  GROUPED_TEMPLATES_ROUTE = 'groupedtemplates',
}
